import React from 'react';
import { StarIcon, UserIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  name: string;
  location: string;
  product?: string;
  text: string;
};

// Testimonios de referencia: reemplazar por testimonios reales y autorizados antes de publicar.
const testimonials: TestimonialProps[] = [{
  name: 'Valentina R.',
  location: 'México',
  product: 'Facilitadora de bienestar',
  text: '“El Libro de los Protocolos me dio la estructura que me faltaba. Ahora sé cómo abrir, desarrollar y cerrar cada sesión, y ya no preparo cada encuentro desde cero.”'
}, {
  name: 'Camila G.',
  location: 'Argentina',
  product: 'Terapeuta holística',
  text: '“El Escudo del Terapeuta cambió mi forma de terminar la jornada. La rutina entre sesiones y el ritual de cierre me ayudaron a separar mi práctica de mi espacio personal.”'
}, {
  name: 'Andrea P.',
  location: 'Perú',
  product: 'Estudiante de Gemoterapia',
  text: '“Recién estaba comenzando y tenía información por todos lados. El Diccionario de Cristales y Chakras se volvió mi consulta de cabecera: lo abro en la tablet antes de cada práctica.”'
}, {
  name: 'Fernanda S.',
  location: 'Chile',
  product: 'Reikista y terapeuta con cristales',
  text: '“Las Fichas de Seguimiento me ordenaron muchísimo. Registro los cristales y las intenciones de cada encuentro, y por fin tengo continuidad entre una sesión y otra.”'
}];
export function TestimonialCard({
  name,
  location,
  product,
  text
}: TestimonialProps) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-8" data-id="element-253" data-mp="14uhi4xjhnvxa">
      <div className="mb-4 flex items-center" data-id="element-254" data-mp="q7ej2mfipf7u">
        <div className="mr-3 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-purple text-brand-goldLight md:mr-4 md:h-12 md:w-12" data-id="element-255" data-mp="q4jz0w0f1wey">
          <UserIcon className="h-5 w-5" aria-hidden="true" data-id="element-256" data-mp="1itqsvhoxdxtv" />
        </div>
        <div data-id="element-257" data-mp="1nn23zv0rt0rl">
          <div className="mb-1 flex text-brand-goldBright" data-id="element-258" data-mp="1nnlc6k0mcasf">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-259" data-mp="1xfwkkvn8r2zy" />)}
          </div>
          <p className="font-semibold text-brand-text md:text-lg" data-id="element-260" data-mp="1sjpdgzj3zlgf">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-261" data-mp="1og9g20z7th2o">
            {location}
            {product ? ` · ${product}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-262" data-mp="1eiv68k7srqjc">{text}</p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-263" data-mp="19qlgb46omqh2">
      <div className="mx-auto max-w-3xl" data-id="element-264" data-mp="14sk1ivgahdbe">
        <TestimonialCard name="María V." location="Colombia" product="Terapeuta holística" text="“Por primera vez tengo un sistema completo para preparar mis sesiones con cristales con orden y claridad. Dejé de buscar información en distintos lugares antes de cada encuentro y ahora sé exactamente por dónde comenzar.”" data-id="element-265" data-mp="14r8vsq3a9vhn" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-266" data-mp="32gntyv5lbl4x">
      <div className="mb-12 text-center" data-id="element-267" data-mp="37fqnpjg4e4xl">
        <h2 className="font-display text-2xl font-bold text-brand-purpleDark md:text-4xl" data-id="element-268" data-mp="37epab8bmt6cp">
          ❤️ LO QUE DICEN QUIENES YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-269" data-mp="3ggf58o4q2nf8">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.text} {...testimonial} data-id="element-270" data-mp="2jr7ff3x2ls5i" />)}
      </div>
    </Section>;
}